import urlApi from './urlApi';
import { getLongReadPosts } from './getLongReadPosts';
export var GET_LONG_READ_REQUEST = 'GET_LONG_READ_REQUEST';
export var GET_LONG_READ_SUCCESS = 'GET_LONG_READ_SUCCESS';
export var GET_LONG_READ_ERROR = 'GET_LONG_READ_ERROR';
export function getLongRead(idArea, idCountry, type) {
    return function (dispatch, getState) {
        var currState = getState();
        dispatch({
            type: GET_LONG_READ_REQUEST,
        });
        urlApi().getLongRead(idArea, idCountry, type).then(function (res) {
            dispatch({
                type: GET_LONG_READ_SUCCESS,
                payload: res,
            });
            dispatch(getLongReadPosts('2', res.data[0].longreadId));
        }).catch(function (e) {
            dispatch({
                type: GET_LONG_READ_ERROR,
            });
        });
    };
}
//# sourceMappingURL=getLongRead.js.mapimport urlApi from './urlApi';
import { getLongReadPosts } from './getLongReadPosts';
export var GET_LONG_READ_REQUEST = 'GET_LONG_READ_REQUEST';
export var GET_LONG_READ_SUCCESS = 'GET_LONG_READ_SUCCESS';
export var GET_LONG_READ_ERROR = 'GET_LONG_READ_ERROR';
export function getLongRead(idArea, idCountry, type) {
    return function (dispatch, getState) {
        var currState = getState();
        dispatch({
            type: GET_LONG_READ_REQUEST,
        });
        urlApi().getLongRead(idArea, idCountry, type).then(function (res) {
            dispatch({
                type: GET_LONG_READ_SUCCESS,
                payload: res,
            });
            dispatch(getLongReadPosts('2', res.data[0].longreadId));
        }).catch(function (e) {
            dispatch({
                type: GET_LONG_READ_ERROR,
            });
        });
    };
}
//# sourceMappingURL=getLongRead.js.map